import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, attachInstallPromptListener } from "@/pwa/register-sw";

// Suppress cross-origin "Script error." (thrown by third-party tvappbuilder embed)
// so it does not trigger CRA's dev error overlay. Content still loads fine.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      if (!e || !e.message) return;
      if (e.message === "Script error." || (!e.filename && !e.error)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
}

attachInstallPromptListener();
registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
